import React from 'react';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import service from './dataService';


class MakelloSlider extends React.Component {

    render() {

        let {min,max,step} = this.props;

        min = parseInt(min, 10);
        max = parseInt(max, 10);
        step = parseInt(step, 10);

        const marksStyle = {
            color: '#1b30a5',
            fontSize: 25,
            fontWeight: 400,
          }; 

        const marks = {
            [min]: {
              style: marksStyle,
              label: <div>${min.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</div>,
            },
            [max]: {
                style: marksStyle,
                label: <div>${max.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</div>,
              }
          };
          
        const sliderContainerStyle = {margin: 'auto', top: 0, left: 0, bottom: 0, right: 0, width: '70%', height: 'auto' }
        const sliderStyle = { backgroundColor: 'white', height: 8};

        const Handle = Slider.Handle;

        const handle = (props) => {
            const { value, dragging, index, ...restProps } = props;

            return (
                <Tooltip
                    id="sliderHandle"
                    prefixCls={"rc-slider-tooltip" + this.props.showTooltip.hidden}
                    overlay={"$"+value.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                    visible={service.data.visibleTooltip}
                    defaultVisible = {true}
                    placement="top"
                    key={index}
                >
                    <Handle value={value} {...restProps} />
                </Tooltip>
            );
        };

        return(
            <div className="sliderLineContainer" style={sliderContainerStyle}>
                <Slider 
                    marks={marks} 
                    trackStyle={sliderStyle} 
                    railStyle={sliderStyle} 
                    id="slider" 
                    min={min} 
                    max={max} 
                    step={step} 
                    defaultValue={Number(this.props.monthlyBill)}
                    handle={handle}
                    onAfterChange={this.props.onMouseUp}
                />
            </div>
        )
    }
}

export default MakelloSlider;